<div class="ml-performance-distribution" [ngClass]="'size-' + size">
  <!-- Chart and Cards (show when data is available) -->
  <div *ngIf="data" class="widget-content">
    <div class="chart-section">
      <highcharts-chart [options]="chartOptions" class="histogram-chart"></highcharts-chart>
    </div>

    <div class="summary-cards">
    <div class="card low-card">
      <div class="card-label">Low Predicted Probability (&lt; 50%)</div>
      <div class="card-metrics">
        <span class="card-value">{{ lowCount }}</span>
        <span class="dotted-line"></span>
        <span class="card-percentage">{{ lowPercentage.toFixed(1) }}% in total</span>
      </div>
    </div>

    <div class="card medium-card">
      <div class="card-label">Medium Predicted Probability (50-70%)</div>
      <div class="card-metrics">
        <span class="card-value">{{ mediumCount }}</span>
        <span class="dotted-line"></span>
        <span class="card-percentage">{{ mediumPercentage.toFixed(1) }}% in total</span>
      </div>
    </div>

    <div class="card high-card">
      <div class="card-label">High Predicted Probability (≥ 70%)</div>
      <div class="card-metrics">
        <span class="card-value">{{ highCount }}</span>
        <span class="dotted-line"></span>
        <span class="card-percentage">{{ highPercentage.toFixed(1) }}% in total</span>
      </div>
    </div>
  </div>
  </div>
</div>
